import { MenuEditPayload } from 'api/menuApi';
import { MenuType, MENU_TYPES, OriginalMenu } from 'types/menu';
import { isNumber } from 'utils/typeUtils';

/**
 * メニュー更新フォーム
 */
export type MenuEditFormFields = {
  /** メニューID */
  id: string;
  /** メニュー名 */
  name: string;
  /** 公開範囲 */
  type: MenuType;
  /** メニュー説明 */
  description: string;
  /** クローラー */
  targetCrawlers: string[];
  /** 並び順 */
  displayOrder: number;
};

export const createMenuEditFormFields = ({
  id = '',
  name = '',
  type = MENU_TYPES.GENERAL,
  description = '',
  targetCrawlers = [],
  displayOrder = 0,
}: Partial<MenuEditFormFields>): MenuEditFormFields => ({
  id,
  name,
  type,
  description,
  targetCrawlers,
  displayOrder,
});

type InjectedArgs = {
  targetCrawlers: string[];
};

export const mapMenuToFormFields = (
  {
    id,
    name = '',
    type = MENU_TYPES.GENERAL,
    description = '',
    displayOrder = 0,
  }: Partial<OriginalMenu>,
  { targetCrawlers = [] }: Partial<InjectedArgs>,
): MenuEditFormFields => ({
  id: isNumber(id) ? id.toString() : '',
  name,
  type,
  description,
  targetCrawlers,
  displayOrder,
});

export const mapFormFieldsToMenuEditPayload = ({
  id,
  name,
  type,
  description,
  displayOrder,
}: MenuEditFormFields): Omit<MenuEditPayload, 'categoryId'> => ({
  id: /^\d+$/.test(id) ? parseInt(id, 10) : null,
  name,
  type,
  description,
  displayOrder,
});
